module.exports = __webpack_public_path__ + "static/media/coin-collected.69da23ec.png";